import React from "react";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import { motion } from "framer-motion";
import CloseButton from "../components/common/CloseButton";

const AboutMe = () => {
  const given = moment("2021-03-27", "YYYY-MM-DD");
  const current = moment().startOf("day");

  const years = given.diff(current, "year");
  current.add(years, "years");

  const months = given.diff(current, "months");
  current.add(months, "months");
  return (
    <motion.div
      className="h-full"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      exit={{ scale: 0, opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="bg-white dark:bg-gray-900 p-5 rounded-custom z-40 ">
        <div className="flex justify-between items-center">
          <h4 className="text-center font-bold text-4xl text-slate-900 dark:text-white tracking-wide uppercase">
            About <span className="text-skin-base">Me</span>
          </h4>
          <CloseButton />
        </div>
        <div className="h-[calc(100vh-130px)] md:h-[calc(100vh-155px)] overflow-y-auto mt-4">
          <div className="flex flex-col ">
            <div className="mb-8">
              <h4 className="text-slate-900 dark:text-white text-xl">
                I am a web developer with a vast array of knowledge in many
                different frontend and backend language, responsive frameworks,
                database and best code practices. My objective is simply to be
                the best web developer that I can be and to contribute to the
                technology industry all that I know and can do.
              </h4>
            </div>
            <div className="flex md:flex-row flex-col mb-8">
              <div className="w-full md:w-1/2">
                <h3 className="flex items-center mb-2 text-lg text-slate-800 dark:text-slate-200">
                  <span className="font-semibold">First Name :&nbsp;</span>
                  <span className="">Shubham</span>
                </h3>
                <h3 className="flex items-center mb-2 text-lg text-slate-800 dark:text-slate-200">
                  <span className="font-semibold">Last Name :&nbsp;</span>
                  <span className="">Gupta</span>
                </h3>
                {/* <h3 className='flex items-center mb-2 text-lg text-slate-800 dark:text-slate-200'>
                                    <span className='font-semibold'>Date Of Birth :&nbsp;</span>
                                    <span className=''>7th September</span>
                                </h3> */}
                <h3 className="flex items-center mb-2 text-lg text-slate-800 dark:text-slate-200">
                  <span className="font-semibold">Nationality :&nbsp;</span>
                  <span className="">Indian</span>
                </h3>
                <h3 className="flex items-center mb-2 text-lg text-slate-800 dark:text-slate-200">
                  <span className="font-semibold">Freelance :&nbsp;</span>
                  <span className="">Available</span>
                </h3>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="flex items-center mb-2 text-lg text-slate-800 dark:text-slate-200">
                  <span className="font-semibold">Experience :&nbsp;</span>
                  <span className="">
                    {Math.abs(years) +
                      "years" +
                      " " +
                      Math.abs(months) +
                      "months"}
                  </span>
                </h3>
                <h3 className="flex items-center mb-2 text-lg text-slate-800 dark:text-slate-200">
                  <span className="font-semibold">Language :&nbsp;</span>
                  <span className="">English, Hindi</span>
                </h3>
                <h3 className="flex items-center mb-2 text-lg text-slate-800 dark:text-slate-200">
                  <span className="font-semibold">Address :&nbsp;</span>
                  <span className="">India</span>
                </h3>
                {/* <h3 className='flex items-center mb-2 text-lg text-slate-800 dark:text-slate-200'>
                                    <span className='font-semibold'>Contact Number :&nbsp;</span>
                                    <span className=''>+91-7004756551</span>
                                </h3> */}
                <h3 className="flex items-center mb-2 text-lg text-slate-800 dark:text-slate-200">
                  <span className="font-semibold">Email :&nbsp;</span>
                  <span className="">workdotsg@gmail.com</span>
                </h3>
              </div>
            </div>
            <div className="mb-5">
              <Link
                to="/resume"
                className="bg-skin-fill text-white rounded-custom px-12 py-4 text-xl uppercase hover:opacity-90 font-semibold"
              >
                View Resume
              </Link>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default AboutMe;
